import type { ReactNode } from "react"

/**
 * 인라인 SVG 아이콘.
 * 아이콘 하나 때문에 아이콘 패키지를 붙이지 않고 필요한 도형만 여기에 모은다.
 */
const ICON_PATHS: Record<string, ReactNode> = {
  dashboard: (
    <>
      <rect
        x="3"
        y="3"
        width="7"
        height="7"
        rx="1"
      />
      <rect
        x="14"
        y="3"
        width="7"
        height="7"
        rx="1"
      />
      <rect
        x="3"
        y="14"
        width="7"
        height="7"
        rx="1"
      />
      <rect
        x="14"
        y="14"
        width="7"
        height="7"
        rx="1"
      />
    </>
  ),
  trophy: (
    <>
      <path d="M8 21h8" />
      <path d="M12 17v4" />
      <path d="M7 4h10v6a5 5 0 0 1-10 0V4Z" />
      <path d="M7 6H4v1a4 4 0 0 0 4 4" />
      <path d="M17 6h3v1a4 4 0 0 1-4 4" />
    </>
  ),
  clipboard: (
    <>
      <rect
        x="5"
        y="4"
        width="14"
        height="17"
        rx="2"
      />
      <path d="M9 4V3h6v1" />
      <path d="M8 10h8M8 14h8M8 18h5" />
    </>
  ),
  users: (
    <>
      <path d="M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" />
      <circle
        cx="9.5"
        cy="7"
        r="4"
      />
      <path d="M17 11a4 4 0 0 0 0-8M21 21v-2a4 4 0 0 0-3-3.87" />
    </>
  ),
  scale: <path d="M12 3v18M5 7h14M5 7l3.5 6h-7L5 7ZM19 7l3.5 6h-7L19 7Z" />,
  bracket: (
    <path d="M4 4h4v5H4M4 15h4v5H4M8 6.5h5v11h3M16 4h4v5h-4M16 15h4v5h-4" />
  ),
  result: (
    <>
      <path d="M6 3h12v18H6z" />
      <path d="m9 8 2 2 4-4M9 15h6" />
    </>
  ),
  building: (
    <path d="M3 21h18M5 21V5l7-3 7 3v16M9 21v-5h6v5M8 8h1M15 8h1M8 12h1M15 12h1" />
  ),
  bell: <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4" />,
  logout: <path d="M10 17l5-5-5-5M15 12H3M21 19V5a2 2 0 0 0-2-2h-6" />,
  menu: <path d="M4 6h16M4 12h16M4 18h16" />,
  close: <path d="M6 6l12 12M18 6 6 18" />,
  calendar: (
    <>
      <rect
        x="3"
        y="5"
        width="18"
        height="16"
        rx="2"
      />
      <path d="M16 3v4M8 3v4M3 10h18" />
    </>
  ),
  arrow: <path d="m9 18 6-6-6-6" />,
  check: <path d="m5 13 4 4L19 7" />,
}

interface IconProps {
  name: string
  size?: number
  className?: string
}

export default function Icon({
  name,
  size = 20,
  className = "",
}: Readonly<IconProps>) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {ICON_PATHS[name]}
    </svg>
  )
}
